﻿module Illy.SafeStack.Client.ActionButton
// This is CarePath specific as it uses components in jQueryUI

open Fable.React
open Fable.React.Props
open Illy.SafeStack.Client.FontAwesome

type 'a Msg =
    | ButtonClicked of 'a

type 'a ActionButton =
    {
        Id: 'a
        Label: string
        Icon: ReactElement
        Disabled: bool
        DisabledTitle: string option
    }


let instance label id icon disabled disabledTitle =
    {
        Id = id
        Label = label
        Icon = icon
        Disabled = disabled
        DisabledTitle = disabledTitle
    }

let add itemName id icon disabled disabledTitle =
    instance (sprintf "Add a new %s" itemName) id icon disabled disabledTitle

let addStandard itemName id = 
    add itemName id (regular "plus" [Fixed] []) false None

let addConditionallyDisabled itemName id disabled disabledTitle =   
    add itemName id (regular "plus" [Fixed] []) disabled disabledTitle

let view model dispatch =
    a
        [
            yield OnClick (fun _ -> if not model.Disabled then ButtonClicked model.Id |> dispatch)
            yield Class (sprintf "action-button%s" (if model.Disabled then " disabled" else ""))
            yield Disabled model.Disabled
            if model.Disabled && model.DisabledTitle.IsSome then yield Title model.DisabledTitle.Value
        ]
        [
            model.Icon
            str model.Label
        ]